import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { JwtHelperService } from '@auth0/angular-jwt';
import {
	AuthnService,
	ComponentBase,
	DeploymentContext,
	getParsedReturnUrl,
	TokenService,
	WebAnalyticsService,
} from '@Common';
import { MagicLinkPayload } from 'company-finder-common';
@Component({
	selector: 'magic-link',
	templateUrl: './magic-link.component.html',
	styleUrls: ['./magic-link.component.scss'],
	standalone: false,
})
export class MagicLinkComponent extends ComponentBase implements OnInit {
	public showProgressIndicator = false;
	private jwtHelperService: JwtHelperService = new JwtHelperService();

	constructor(
		deploymentContext: DeploymentContext,
		private _authnService: AuthnService,
		private _webAnalyticsService: WebAnalyticsService,
		private _router: Router,
		private route: ActivatedRoute
	) {
		super(deploymentContext);
	}

	public get jwt(): string {
		return this.route.snapshot.queryParams['jwt'] ?? '';
	}

	public async ngOnInit(): Promise<void> {
		this._authnService.clearJnjLoggedOut();

		this.showProgressIndicator = true;
		setTimeout(async () => {
			if (!(await this._authnService.isMagicLinkValid(this.jwt))) {
				this._router.navigate(['']);
				return;
			}

			const avoidInterpolationOfSensitiveVariablesBuildWarning =
				this._authnService.currentUsername;
			this._webAnalyticsService.trackEvent('login-via-magic-link', {
				category: 'successful-login',
				label: `${avoidInterpolationOfSensitiveVariablesBuildWarning} - ${this._authnService.userRole}`,
			});

			const { targetUrl } =
				this.jwtHelperService.decodeToken<MagicLinkPayload>(this.jwt);
			this._router.navigateByUrl(targetUrl);
		}, this._deploymentContext.progressIndicator.pauseForStaticIndicator);
	}
}
